<template>
  <CContainer fluid>
    <h3>Calendario de <strong>Actividades</strong></h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="5" sm="5">
            <CRow>
              <CCol>
                <CButton 
                  color="success"
                  @click="showPanelActionCalendarActivities=true">
                  <i class="bi bi-plus-circle h4 mr-2 align-middle"></i>
                  <span>Agregar</span>
                </CButton>
              </CCol>
            </CRow>
            <CDataTable 
              hover
              class="mt-3"
              :items="items"
              :fields="fields">
              <template #fecha="{item}">
                <td>
                  <div>
                    <i class="bi bi-calendar3 text-info mr-1"></i>
                    <span>{{ moment(item.fecha_Inicial).format("DD/MM/YYYY") }}</span>
                  </div>
                  <div>
                    <i class="bi bi-clock text-success mr-1"></i>
                    {{ moment(item.fecha_Inicial).format("hh:mm a") }}
                  </div>
                  <div>
                    <i class="bi bi-clock text-danger mr-1"></i>
                    {{ moment(item.fecha_Final).format("hh:mm a") }}
                  </div>
                </td>
              </template>
              <template #asunto="{item}">
                <td>
                  <div>
                    {{ item.asunto }}
                  </div>
                </td>
              </template>
              <template #acciones="{item}">
                <td>
                  <div class="d-flex justify-content-center">
                    <a href="#" @click="(event) => tryDelete(event, item.id_Calendario)">
                      <i class="bi bi-trash3 text-danger h5"></i>
                    </a>
                    <a href="#" @click="(event) => openPanelTracking(event)">
                      <i class="bi bi-list-check text-s3purple h5 ml-2"></i>
                    </a>
                  </div>
                </td>
              </template>

            </CDataTable>
          </CCol>
          <CCol col="7" sm="7">
            <FullCalendar :options="calendarOptions" />
          </CCol>
        </CRow>
      </CCardBody>

      <CElementCover v-show="loading" />
    </CCard>

    <RightSideBar size="md" class="bg-s3grey" :show="showPanelActionCalendarActivities">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <span>Agregar <strong>actividad</strong> al Calendario</span>
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="calendarActivitiesFields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success" 
                :class="isValidForm ? '' : 'disabled'" 
                :disabled="!isValidForm"
                @click="(event) => saveCalendarActivity(event)">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton 
                color="danger" 
                variant="outline" 
                class="ml-2" 
                @click="showPanelActionCalendarActivities=false">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>
  </CContainer>
</template>

<script>
  import moment from "moment";
  import CONSTANTS from "@/constants";
  import { dataGridCalendario } from "@/apiDataGrids";
  import { crudCalendario } from "@/apiCRUD";

  import FullCalendar from "@fullcalendar/vue";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import timeGridPlugin from "@fullcalendar/timegrid";
  import interactionPlugin from "@fullcalendar/interaction";

  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";

  const fields = [
    {
      key: "fecha",
      label: "Fecha",
      _style: "text-align:center;"
    },
    {
      key: "asunto",
      label: "Asunto",
      _style: "text-align:center;"
    },
    {
      key: "acciones",
      label: ""
    }
  ]

  export default {
    name: "CalendarActivities",
    data() {
      const self = this;
      return {
        loading: false,
        showPanelActionCalendarActivities: null,
        fields,
        calendarActivitiesFields: [
          {
            key: "typeCalendar",
            label: "Tipo Calendario",
            value: "",
            type: "select",
            required: true,
            options: [
              {
                label: "Seleccionar",
                value: ""
              },
              {
                label: "Reunion",
                value: "R"
              },
              {
                label: "Visita",
                value: "V"
              }
            ]
          },
          {
            key: "company",
            label: "Empresa",
            value: "",
            type: "autocomplete",
            options: [],
            update_search(value) {
              self.searchDirectory(value);
            }
          },
          {
            key: "subject",
            label: "Asunto",
            value: "",
            type: "text",
            required: true
          },
          {
            key: "dayActivitie",
            label: "Fecha Actividad",
            value: "",
            type: "date",
            required: true,
            prepend_content: {
              name: "calendar-date"
            }
          },
          {
            key: "activeAllDay",
            label: "Actividad todo el Dia",
            value: false,
            type: "switch",
            on_change(value) {
              console.log(value);
              self.onChangeSwitchActiveAllDay(value);
            }
          },
          {
            key: "startTime",
            label: "Hora Inicio",
            value: "",
            type: "time",
            required: true,
            // disabled: true,
            prepend_content: {
              name: "clock"
            }
          },
          {
            key: "endTime",
            label: "Hora Final",
            value: "",
            type: "time",
            required: true,
            // disabled: true,
            prepend_content: {
              name: "clock"
            },
            custom_validation() {
              let startDate = self.calendarActivitiesFields[2].value;
              let startTime = self.calendarActivitiesFields[4].value;
              let endTime = self.calendarActivitiesFields[5].value;

              return moment(`${startDate}T${startTime}`).isBefore(`${startDate}T${endTime}`);
            }
          },
          {
            key: "comments",
            label: "Observaciones",
            value: "",
            type: "textarea",
            custom_validation(value) {
              return value.length > 0 ? (value.length <= 100 ? true : false) : true;
            }
          },
          {
            key: "contact",
            label: "Contacto",
            value: "",
            type: "text"
          },
          {
            key: "direction",
            label: "Direccion",
            value: "",
            type: "text"
          },
          {
            key: "phones",
            label: "Telefono",
            value: "",
            type: "text"
          },
          {
            key: "email",
            label: "Correo Electronico",
            value: "",
            type: "text"
          }
        ],
        calendarOptions: {
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin
          ],
          headerToolbar: {
            left: "prev, next, today",
            center: "",
            right: "dayGridMonth, timeGridWeek"
          },
          titleFormat: {
            year: "numeric",
            month: "short",
            day: "numeric"
          },
          buttonText: {
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Dia",
            list: "Lista"
          },
          initialView: "timeGridWeek",
          weekends: true,
          editable: true,
          selectable: true,
          selectMirror: false,
          events: []
        },
        items: [],
        directory: [],
        id_CalendarSelected: "",
        id_Empleado: ""
      }
    },
    components: {
      FullCalendar,
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      moment,
      async getData() {
        this.loading = true;

        try {
          const { count, results } = await dataGridCalendario(this, this.id_Empleado, null);
          
          console.log(count);

          this.items = results;
          this.calendarOptions.events = results.map(item => {
            return {
              id: item.id_Calendario,
              title: item.asunto,
              start: item.fecha_Inicial,
              end: item.fecha_Final,
              description: item.observaciones
            }
          });
          
            // {
            //   id: 2,
            //   title: "Evento de todo el dia",
            //   start: "2024-11-14",
            //   allDay: true
            // },
            // {
            //   id: 3,
            //   title: "Hora de Almuerzo",
            //   start: "2024-11-12T12:00:00",
            //   end: "2024-11-12T14:00:00",
            //   durationEditable: true,
            //   description: 'Lecture...',
            //   color: "green",
            //   textColor: "black",
            //   borderColor: "yellow"
            // }            
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async saveCalendarActivity(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loading = true;

        try {
          let activityDate = this.calendarActivitiesFields[2].value;
          let startTimeActivity = this.calendarActivitiesFields[4].value;
          let endTimeActivity = this.calendarActivitiesFields[5].value;
          let startDateActivity, endDateActivity;

          if (this.calendarActivitiesFields[3].value) {
            startDateActivity = moment(`${activityDate}T00:00:00`);
            endDateActivity = null;
          } else {
            startDateActivity = moment.utc(`${activityDate}T${startTimeActivity}`).local();
            endDateActivity = moment.utc(`${activityDate}T${endTimeActivity}`).local();
          }

          const data = {
            "personal": this.id_Empleado,
            "tipo_Calendario": this.calendarActivitiesFields[0].value,
            "asunto": this.calendarActivitiesFields[1].value,
            "activar_DiaCompleto": "V",
            "fecha_Inicial": startDateActivity,
            "fecha_Final": endDateActivity,
            "clase_Seguimiento": null,
            "prioridad": "N",
            "observaciones": this.calendarActivitiesFields[6].value ? this.calendarActivitiesFields[6].value : null,
            "empresa": this.calendarActivitiesFields[7].value ? this.calendarActivitiesFields[7].value : null,
            "contacto": this.calendarActivitiesFields[8].value ? this.calendarActivitiesFields[8].value : null,
            "direccion": this.calendarActivitiesFields[9].value ? this.calendarActivitiesFields[9].value : null,
            "telefonos": this.calendarActivitiesFields[10].value ? this.calendarActivitiesFields[10].value : null,
            "correo_Electronico": this.calendarActivitiesFields[11].value ? this.calendarActivitiesFields[11].value : null,
            "usuario": this.$store.state.user.data.id_Usuario
          }

          const dataResponse = await crudCalendario(this, "create", null, data);

          this.clearCalendarActivities();
          this.getData();

          console.log(dataResponse);
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
          this.showPanelActionCalendarActivities = false;
        }
      },
      tryDelete(e, idCalendar) {
        e.preventDefault();
        e.stopPropagation();

        this.id_CalendarSelected = idCalendar;
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteCalendarActivity();
        }).catch(() => {
          this.$alert("Se cancelo la accion!", "", "warning", CONSTANTS.configSimpleConfirm);
        });
      },
      async deleteCalendarActivity() {
        this.loading = true;

        try {
          await crudCalendario(this, "delete", this.id_CalendarSelected);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });

          this.getData();
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      openPanelTracking(e) {
        e.preventDefault();
        e.stopPropagation();

        console.log("Entro aqui... :-)");
      },
      clearCalendarActivities() {
        this.calendarActivitiesFields.forEach((field) => {
          if (field.type === "switch") {
            field.value = false;
          } else {
            field.value = "";
          }
        })
      },
      onChangeSwitchActiveAllDay(value) {
        this.calendarActivitiesFields[4].disabled = !value;
        this.calendarActivitiesFields[5].disabled = !value;

        if (value) {
          this.calendarActivitiesFields[4].value = "";
          this.calendarActivitiesFields[5].value = "";
        } else {
          this.calendarActivitiesFields[4].value = moment().formar("HH:mm");
          this.calendarActivitiesFields[5].value = moment().format("HH:mm");
        }
      }
    },
    computed: {
      isValidForm() {
        return this.calendarActivitiesFields.every(field => {
          if (field.required) {
            if (field.key === "endTime") {
              let startDate = this.calendarActivitiesFields[2].value;
              let startTime = this.calendarActivitiesFields[4].value;
              let endTime = this.calendarActivitiesFields[5].value;

              return moment(`${startDate}T${startTime}`).isBefore(`${startDate}T${endTime}`);
            }
            if (typeof field.value === "string") {
              return field.value.length > 0;
            }

            return field.value > 0;
          } else {
            if (field.key === "comments") {
              return field.value.length > 0 ? (field.value.length <= 10 ? true : false) : true;
            }
          }
          
          return true;
        });
      }
    },
    mounted() {
      this.id_Empleado = this.$store.state.user.data.id_Empleado;

      this.getData();
    }
  }
</script>